import { IContract } from '../types/model.types';

export const BLANK_CONTRACT_OBJECT: IContract = {
    html_body:
        '<h1><span style="font-size:36px;"><strong>Contract</strong></span>&nbsp;</h1><p>&nbsp;</p><p>Type (or copy and paste) the content of your contract here</p>',
    fields_metadata: []
};
